import { useState } from 'react';

let docFont = "Helvetica, Arial, sans-serif";

export function Stats_Shape() {
	//const [docFont, setDocFont] = useState("Helvetica, Arial, sans-serif");
	const [warmUpDone, setWarmUpDone] = useState(false);
	const [targetDone, setTargetDone] = useState(false);
	const [initiation, setInitiation] = useState(false);
	const [terminology, setTerminology] = useState(false);
	const [content, setContent] = useState(1);

	function text2Speech(num) {
		copyToClipboard(num);
		window.open("https://www.naturalreaders.com/online/");
	}

	function translateText(num) {
		const e = document.getElementById("label" + num);
		navigator.clipboard.writeText(e.textContent);
		window.open("http://translate.google.com/?sl=en&tl=th&op=translate&text=" + e.textContent.replaceAll("%", "%25"));
	}

	function copyToClipboard(num) {
		const e = document.getElementById("label" + num);
		navigator.clipboard.writeText(e.textContent);
		alert(`Text copied to clipboard. Ready to paste.`)
	}

	//function changeFont() {
	//	const e = document.getElementById("select_font");
	//	setDocFont(e.value);
	//}

	function gotoLT() {
		setInitiation(true);
	}

	function gotoInit() {
		setWarmUpDone(true);
	}

	function gotoTerms() {
		setTargetDone(true);
	}

	function gotoData() {
		setTerminology(true);
	}

	function gotoContent(num) {
		setContent(num);
	}

	if (!warmUpDone) {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}` }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >On your chromebook or laptop:</span>
					</h1>

					<p>
						<label id="label101">
							1. go to Stapplet.com in your web browser <br />
							2. select 1 Quantitative Variable, Single Group <br />
							<span style={{ "paddingLeft": "50px"}}>Variable name = Hits per Season </span><br />
							<span style={{ "paddingLeft": "50px" }}>Input = Raw data </span><br />
							3. enter the following data values: <br />
							<span style={{ "paddingLeft": "50px" }}>Group 1 </span>
							<span style={{ "paddingLeft": "25px" }}>Name: Shohei Ohtani </span><br />
							<span style={{ "paddingLeft": "168px" }}>Data: 93 110 29 138 160 151 197 172 </span><br />
							<span style={{ "paddingLeft": "50px" }}>Group 2 </span>
							<span style={{ "paddingLeft": "25px" }}>Name: Aaron Judge </span><br />
							<span style={{ "paddingLeft": "168px" }}>Data: 15 154 115 103 26 158 177 98 180 179 </span><br />
							4. click the &quot;Begin Analysis&quot; button <br />
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(101)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(101)}>Translate</button>

					<p>&nbsp;</p>

					<button type="button" className="gray-button" onClick={() => gotoInit()}>Done! Next ...</button>
				</div >
			</>
		);
	}
	else if (!initiation) {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}` }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Let&apos;s Play Shapes Pyramid</span>
					</h1>

					<p>
						<label id="label102">
							<u>Rules</u><br />
							You and your neighbor are a team. <br />
							Decide who will give the clues and who will do the guessing. <br />
							The one guessing must face away from the board. <br />
							There are a total of six shape names forming a pyramid. <br />
							The one guessing must name all six of the shapes to win. <br />
							Clues cannot contain ANY form or part <br />
							of the word to be guessed. <br />
							<br /><br />
							Wait until I say GO.
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(102)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(102)}>Translate</button>

					<p>&nbsp;</p>

					<button type="button" className="gray-button" onClick={() => gotoLT()}>Done! Next ...</button>
				</div >
			</>
		);
	}
	else if (!targetDone) {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}`, "textAlign": "center" }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Learning Target</span>
					</h1>

					<p>
						<label id="label103">
							I can distinguish and interpret <br />
							different shapes of data distribution, <br />
							compare and explain differences in statistical measures, <br />
							and identify outliers, <br />
							evaluating their influence on statistical measures. <br />
							<br />
							On a set of interpretation exercises, <br />
							I will achieve at least 75% accuracy. <br />
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(103)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(103)}>Translate</button>

					<p>&nbsp;</p>

					<button type="button" className="gray-button" onClick={() => gotoTerms()}>Done! Next ...</button>
				</div >
			</>
		);
	}
	else if (!terminology) {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}` }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Terminology</span>
					</h1>

					<p>
						<label id="label104">
							<b>Modality</b> = the number of modes (peaks) in a dataset <br />
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(104)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(104)}>Translate</button>

					<p>
						<label id="label105">
							<b>Symmetry</b> = a balanced distribution of data values where the left and right sides mirror each other around a central point <br />
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(105)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(105)}>Translate</button>

					<p>
						<label id="label106">
							<b>Skew</b> = the degree of asymmetry in a distribution <br />
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(106)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(106)}>Translate</button>

					<p>
						<label id="label107">
							<b>Variability</b> = the extent to which data points differ from each other and from the center of a distribution <br />
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(107)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(107)}>Translate</button>

					<p>
						<label id="label108">
							<b>Outlier</b> = a data point that significantly differs from other observations in a dataset <br />
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(108)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(108)}>Translate</button>

					<p>&nbsp;</p>

					<button type="button" className="gray-button" onClick={() => gotoData()}>Done! Next ...</button>
				</div >
			</>
		);
	}
	else {
		if (content == 1) {
			return (
				<>
					<div className="microteach" style={{ "fontFamily": `${docFont}`, "textAlign": "center" }}>

						<label id="label110">
							<h1>
								<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Understanding Uniform Data Plots</span>
							</h1>
						</label>

						<button type="button" className="gray-button" onClick={() => text2Speech(110)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(110)}>Translate</button>

						<p>
							<label id="label111">
								<span style={{ "fontWeight": "700"}}>Even Distribution of Values</span>: <br />
								Uniform data plots show values evenly spread across a range, with each outcome equally probable.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(111)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(111)}>Translate</button>

						<p>
							<label id="label112">
								<span style={{ "fontWeight": "700" }}>Flat Plot Appearance</span>: <br />
								Uniform plots commonly look like a flat band in histograms or dot plots, indicating consistent probabilities.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(112)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(112)}>Translate</button>

						<p>
							<label id="label113">
								<span style={{ "fontWeight": "700" }}>Role in Probability Modeling</span>: <br />
								Uniform distributions are vital in probability and statistics, modeling random processes with constant probabilities.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(113)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(113)}>Translate</button>

						<p>&nbsp;</p>

						<button type="button" className="gray-button" onClick={() => gotoContent(2)}>Done! Next ...</button>
					</div >
				</>
			);
		}
		else if (content == 2) {
			return (
				<>
					<div className="microteach" style={{ "fontFamily": `${docFont}`, "textAlign": "center" }}>

						<label id="label120">
							<h1>
								<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Understanding Modality in Statistics</span>
							</h1>
						</label>

						<button type="button" className="gray-button" onClick={() => text2Speech(120)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(120)}>Translate</button>

						<p>
							<label id="label121">
								<span style={{ "fontWeight": "700" }}>Definition of Modality</span>: <br />
								Modality describes the number of peaks or modes in a data distribution, indicating its structure and complexity.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(121)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(121)}>Translate</button>

						<p>
							<label id="label122">
								<span style={{ "fontWeight": "700" }}>Types of Modality</span>: <br />
								Data distributions can be unimodal, bimodal, or multimodal, each representing different data patterns and clusters.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(122)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(122)}>Translate</button>

						<p>
							<label id="label123">
								<span style={{ "fontWeight": "700" }}>Importance of Identifying Modality</span>: <br />
								Recognizing modality helps detect clusters or subgroups and guides the selection of suitable statistical analyses.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(123)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(123)}>Translate</button>

						<p>&nbsp;</p>

						<button type="button" className="gray-button" onClick={() => gotoContent(3)}>Done! Next ...</button>
					</div >
				</>
			);
		}
		else if (content == 3) {
			return (
				<>
					<div className="microteach" style={{ "fontFamily": `${docFont}`, "textAlign": "center" }}>

						<label id="label130">
							<h1>
								<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Understanding Statistical Symmetry</span>
							</h1>
						</label>

						<button type="button" className="gray-button" onClick={() => text2Speech(130)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(130)}>Translate</button>

						<p>
							<label id="label131">
								<span style={{ "fontWeight": "700" }}>Definition of Symmetry</span>: <br />
								Statistical symmetry means a data distribution mirrors itself around a central value, forming balanced patterns.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(131)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(131)}>Translate</button>

						<p>
							<label id="label132">
								<span style={{ "fontWeight": "700" }}>Importance of Symmetric Distributions</span>: <br />
								Symmetric distributions, such as the normal distribution, simplify data interpretation and statistical analysis tasks.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(132)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(132)}>Translate</button>

						<p>
							<label id="label133">
								<span style={{ "fontWeight": "700" }}>Applications in Data Analysis</span>: <br />
								Detecting symmetry aids in identifying patterns, improving data assessment, and selecting proper statistical inference methods.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(133)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(133)}>Translate</button>

						<p>&nbsp;</p>

						<button type="button" className="gray-button" onClick={() => gotoContent(4)}>Done! Next ...</button>
					</div >
				</>
			);
		}
		if (content == 4) {
			return (
				<>
					<div className="microteach" style={{ "fontFamily": `${docFont}`, "textAlign": "center" }}>

						<label id="label140">
							<h1>
								<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Understanding Skewness</span>
							</h1>
						</label>

						<button type="button" className="gray-button" onClick={() => text2Speech(140)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(140)}>Translate</button>

						<p>
							<label id="label141">
								<span style={{ "fontWeight": "700" }}>Definition of Skewness</span>: <br />
								Skewness measures the asymmetry in a statistical distribution, indicating whether data tails off more to one side.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(141)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(141)}>Translate</button>

						<p>
							<label id="label142">
								<span style={{ "fontWeight": "700" }}>Right (positive) and Left (negative) Skew</span>: <br />
								A positively skewed distribution has a longer right tail, while a negatively skewed one has a longer left tail.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(142)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(142)}>Translate</button>

						<p>
							<label id="label143">
								<span style={{ "fontWeight": "700" }}>Impact on Data Analysis</span>: <br />
								Skewness affects interpretation of statistical measures like the mean and median, influencing analysis accuracy and decisions.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(143)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(143)}>Translate</button>

						<p>&nbsp;</p>

						<button type="button" className="gray-button" onClick={() => gotoContent(5)}>Done! Next ...</button>
					</div >
				</>
			);
		}
		else {
			return (
				<>
					<div className="microteach" style={{ "fontFamily": `${docFont}`, "textAlign": "center" }}>

						<label id="label150">
							<h1>
								<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Understanding Statistical Outliers</span>
							</h1>
						</label>

						<button type="button" className="gray-button" onClick={() => text2Speech(150)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(150)}>Translate</button>

						<p>
							<label id="label151">
								<span style={{ "fontWeight": "700" }}>Definition of Outliers</span>: <br />
								Outliers are data points that differ greatly from other values in a dataset, often signaling unusual patterns.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(151)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(151)}>Translate</button>

						<p>
							<label id="label152">
								<span style={{ "fontWeight": "700" }}>Causes of Outliers</span>: <br />
								Outliers can arise from measurement variability, experimental errors, or novel phenomena within data collection processes.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(152)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(152)}>Translate</button>

						<p>
							<label id="label153">
								<span style={{ "fontWeight": "700" }}>Importance of Detection</span>: <br />
								Detecting and analyzing outliers is vital since they can skew results, provide insights, or indicate data quality problems.
							</label>
						</p>

						<button type="button" className="gray-button" onClick={() => text2Speech(153)}>Text to Speech</button>
						<button type="button" className="gray-button" onClick={() => translateText(153)}>Translate</button>

					</div >
				</>
			);
		}
	}
}
